/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExposureResponseViewModel } from './ExposureResponseViewModel';
import {
    ExposureResponseViewModelFromJSON,
    ExposureResponseViewModelFromJSONTyped,
    ExposureResponseViewModelToJSON,
} from './ExposureResponseViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfExposureResponseViewModel
 */
export interface ResultOfExposureResponseViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfExposureResponseViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfExposureResponseViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfExposureResponseViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfExposureResponseViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfExposureResponseViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfExposureResponseViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfExposureResponseViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ExposureResponseViewModel}
     * @memberof ResultOfExposureResponseViewModel
     */
    data?: ExposureResponseViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfExposureResponseViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfExposureResponseViewModel interface.
 */
export function instanceOfResultOfExposureResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfExposureResponseViewModelFromJSON(json: any): ResultOfExposureResponseViewModel {
    return ResultOfExposureResponseViewModelFromJSONTyped(json, false);
}

export function ResultOfExposureResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfExposureResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ExposureResponseViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfExposureResponseViewModelToJSON(value?: ResultOfExposureResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ExposureResponseViewModelToJSON(value.data),
        'Count': value.count,
    };
}

